<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = [
							['adv_id','Adverister'],
							['adv_offer_id','Adv Offer Id']
						].map(v => {
			return { value: v[0], label: v[1] };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

